export const DUBYA_TOKEN = {
  name: 'The W Arcade',
  symbol: 'DUBYA',
  chain: 'Solana',
  mint: 'DiYfk6MCTrSUHSEWESDhqjVH6CUx6yR9HYsaDPJ9pump',
  pumpUrl:
    'https://pump.fun/coin/DiYfk6MCTrSUHSEWESDhqjVH6CUx6yR9HYsaDPJ9pump',
  explorerUrl:
    'https://solscan.io/token/DiYfk6MCTrSUHSEWESDhqjVH6CUx6yR9HYsaDPJ9pump',
  vidyaPreviewUrl:
    'https://dubya.ai/?view=vidya&demo=dubya-drop&utm_source=trinity&utm_medium=product&utm_campaign=dubya_ecosystem',
  communityUrl: 'https://x.com/trinitydubya',
  profileLandingUrl:
    'https://dubya.ai/?utm_source=x&utm_medium=profile&utm_campaign=dubya_profile',
  sharedBuildUrl:
    'https://dubya.ai/?utm_source=x&utm_medium=organic&utm_campaign=shared_build',
  sharedGameUrl:
    'https://dubya.ai/?view=vidya&demo=dubya-drop&utm_source=x&utm_medium=organic&utm_campaign=shared_game',
  referralGameUrl:
    'https://dubya.ai/?view=vidya&demo=dubya-drop&utm_source=direct&utm_medium=referral&utm_campaign=shared_game',
  sharedAnswerUrl:
    'https://dubya.ai/?utm_source=x&utm_medium=organic&utm_campaign=shared_answer',
  referralAnswerUrl:
    'https://dubya.ai/?utm_source=direct&utm_medium=referral&utm_campaign=shared_answer',
} as const;

export const VIDYA_PREVIEW_GAMES = [
  {
    title: 'Adjustris',
    version: '1.1',
    platform: 'Game Boy homebrew',
    access: 'Free demo',
    license: 'CC0-1.0',
    sourceUrl: 'https://github.com/tbsp/Adjustris/tree/v1.1',
    releaseUrl: 'https://github.com/tbsp/Adjustris/releases/tag/v1.1',
  },
  {
    title: 'SpaceGB',
    version: '1.0.0',
    platform: 'Game Boy homebrew',
    access: 'INSERT pass',
    license: 'MIT',
    sourceUrl: 'https://github.com/BotRandomness/SpaceGB/tree/v1.0.0',
    releaseUrl: 'https://github.com/BotRandomness/SpaceGB/releases/tag/v1.0.0',
  },
] as const;

export const DUBYA_CREATOR_DISCLOSURE = {
  reportedHolding: '7.26% of total supply',
  reportedAt: '2026-10-06 04:34 America/Los_Angeles',
  holdingBasis:
    'Pump.fun checkpoint; the live percentage can change and should be verified on-chain.',
  rewardCheckpoint: '0.0172 SOL unclaimed (~$2.06); 0 SOL donated',
  rewardReportedAt: '2026-10-06 04:34 America/Los_Angeles',
  rewardVisibility:
    'Pump.fun is the source of truth for live unclaimed creator rewards and charity donations; changing balances are not hardcoded here.',
  lockStatus:
    'No public lock, vesting schedule, price support, or no-sale promise is represented.',
  marketIntegrity:
    'No coordinated wallets, wash trading, circular or matched trading, fake holders, or manufactured engagement.',
} as const;

export function shortMint(mint = DUBYA_TOKEN.mint): string {
  return `${mint.slice(0, 6)}…${mint.slice(-6)}`;
}

export function buildSharedAnswerIntent(): string {
  const text = [
    "I tried W AI, Dubya AI's free guest chat—no account or wallet required.",
    `Explore the working product first: ${DUBYA_TOKEN.sharedAnswerUrl}`,
    '$DUBYA is the arcade-access token for W AI + Vidya.',
  ].join('\n\n');

  return `https://x.com/intent/post?text=${encodeURIComponent(text)}`;
}

export function buildSharedBuildIntent(): string {
  const text = [
    '$DUBYA is the arcade token for W AI + Vidya.',
    `Try W AI free: ${DUBYA_TOKEN.sharedBuildUrl}`,
    `Verify the official mint: ${DUBYA_TOKEN.mint}`,
  ].join('\n\n');

  return `https://x.com/intent/post?text=${encodeURIComponent(text)}`;
}

export function buildSharedGameIntent(score: number): string {
  const safeScore = Number.isSafeInteger(score) && score >= 0 ? Math.min(score, 999) : 0;
  const challengeUrl = new URL(DUBYA_TOKEN.sharedGameUrl);
  challengeUrl.searchParams.set('challenge', String(safeScore));
  const text = [
    `I scored ${safeScore} in DUBYA Drop — a free 15-second browser arcade demo.`,
    `Can you beat it? Play free: ${challengeUrl.toString()}`,
    'Free demo: no wallet, payment, or token reward.',
  ].join('\n\n');

  return `https://x.com/intent/post?text=${encodeURIComponent(text)}`;
}

export function buildReferralGameUrl(score: number): string {
  const safeScore = Number.isSafeInteger(score) && score >= 0 ? Math.min(score, 999) : 0;
  const challengeUrl = new URL(DUBYA_TOKEN.referralGameUrl);
  challengeUrl.searchParams.set('challenge', String(safeScore));
  return challengeUrl.toString();
}
